var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcLayout',{staticClass:"mainLoader",attrs:{"align-center":"","justify-center":""}},[_c('VcLoader',{attrs:{"color":"#0C315E"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }